import styled from '@emotion/styled'
import InputLabel from 'components/patterns/Inputs/InputLabel'
import { themeColor } from 'utils/styles'

export const StyledInputLabel = styled(InputLabel)`
  margin-top: 20px;
  display: block;
`

export const StyledUl = styled.ul`
  padding-left: 15px;
  margin-top: 0;
`

export const StyledLi = styled.li`
  & + li {
    padding-top: 10px;
  }

  span {
    background ${themeColor('featureTimerInfoHighlight')}
  }
`
